// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workflow-stepper {
  width: 100%;
  padding: 16px 60px;
  background: #fff;
}

@media (max-width: 768px) {
  .workflow-stepper {
    padding: 12px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/workflow-stepper/WorkflowStepper.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".workflow-stepper {\n  width: 100%;\n  padding: 16px 60px;\n  background: #fff;\n}\n\n@media (max-width: 768px) {\n  .workflow-stepper {\n    padding: 12px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
